import { IXVIListColumn } from '@shared/types';
import { MODIFIED_DATE_COLUMN, ENTITY_ID_COLUMN, ID_COLUMN } from '../base';

/**
 * Default entities columns.
 * This columns shown by default in each entities list.
 */
export const DEFAULT_ENTITIES_COLUMNS: IXVIListColumn[] = [
  MODIFIED_DATE_COLUMN,
  ENTITY_ID_COLUMN,
  ID_COLUMN,
];
